import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Copy20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.5 1.25C4.80964 1.25 4.25 1.80965 4.25 2.5V14.5C4.25 15.1904 4.80964 15.75 5.5 15.75H17.5C18.1904 15.75 18.75 15.1904 18.75 14.5V2.5C18.75 1.80964 18.1904 1.25 17.5 1.25H5.5ZM5.75 14.25V2.75H17.25V14.25H5.75Z'
      fill='currentColor'
    />
    <path
      d='M2.75 5V17.25H15V18.75H2.59091C1.85035 18.75 1.25 18.1497 1.25 17.4091V5H2.75Z'
      fill='currentColor'
    />
  </Svg>
);

Copy20.displayName = 'Copy20';
export default Copy20;
